"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageIn = void 0;
class MessageIn {
    constructor() {
    }
    static getAttributeTypeMap() {
        return MessageIn.attributeTypeMap;
    }
}
exports.MessageIn = MessageIn;
MessageIn.discriminator = undefined;
MessageIn.attributeTypeMap = [
    {
        "name": "application",
        "baseName": "application",
        "type": "ApplicationIn",
        "format": ""
    },
    {
        "name": "channels",
        "baseName": "channels",
        "type": "Array<string>",
        "format": ""
    },
    {
        "name": "eventId",
        "baseName": "eventId",
        "type": "string",
        "format": ""
    },
    {
        "name": "eventType",
        "baseName": "eventType",
        "type": "string",
        "format": ""
    },
    {
        "name": "payload",
        "baseName": "payload",
        "type": "any",
        "format": ""
    },
    {
        "name": "payloadRetentionPeriod",
        "baseName": "payloadRetentionPeriod",
        "type": "number",
        "format": "int64"
    },
    {
        "name": "tags",
        "baseName": "tags",
        "type": "Array<string>",
        "format": ""
    },
    {
        "name": "transformationsParams",
        "baseName": "transformationsParams",
        "type": "any",
        "format": ""
    }
];
//# sourceMappingURL=MessageIn.js.map